import React from 'react';
import { 
  Box, 
  Typography, 
  Paper,
  Alert,
  Chip,
  Avatar,
  Divider,
} from '@mui/material';
import { Person } from '@mui/icons-material';

import { useAuth } from '../contexts/AuthContext.tsx';

const ProfilePage: React.FC = () => {
  const { user } = useAuth();

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Profile
      </Typography>
      <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 3 }}>
        Manage your account settings and information
      </Typography>

      <Paper sx={{ p: 3, mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, mb: 3 }}>
          <Avatar sx={{ width: 80, height: 80, fontSize: '2rem' }}>
            {user?.first_name?.charAt(0)}
          </Avatar>
          <Box>
            <Typography variant="h5" gutterBottom>
              {user?.full_name}
            </Typography>
            <Typography variant="body1" color="text.secondary" gutterBottom>
              {user?.email}
            </Typography>
            <Chip 
              label={user?.role?.replace('_', ' ').toUpperCase()} 
              color="primary" 
              size="small"
            />
          </Box>
        </Box>

        <Divider sx={{ my: 3 }} />

        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 2 }}>
          {user?.phone && (
            <Box>
              <Typography variant="subtitle2" color="text.secondary">Phone</Typography>
              <Typography variant="body1">{user.phone}</Typography>
            </Box>
          )}
          
          {user?.company_name && (
            <Box>
              <Typography variant="subtitle2" color="text.secondary">Company</Typography>
              <Typography variant="body1">{user.company_name}</Typography>
            </Box>
          )}
          
          {user?.mcs_number && (
            <Box>
              <Typography variant="subtitle2" color="text.secondary">MCS Number</Typography>
              <Typography variant="body1">{user.mcs_number}</Typography>
            </Box>
          )}

          <Box>
            <Typography variant="subtitle2" color="text.secondary">Account Status</Typography>
            <Chip 
              label={user?.is_active ? 'Active' : 'Inactive'} 
              color={user?.is_active ? 'success' : 'error'}
              size="small"
            />
          </Box>
          
          <Box>
            <Typography variant="subtitle2" color="text.secondary">Member Since</Typography>
            <Typography variant="body1">
              {user?.created_at ? new Date(user.created_at).toLocaleDateString() : 'N/A'}
            </Typography>
          </Box>
        </Box>
      </Paper>

      <Paper sx={{ p: 3 }}>
        <Alert severity="info">
          <Typography variant="h6" gutterBottom>
            🚧 Profile Editing Coming Soon
          </Typography>
          Profile editing functionality will be available in a future update. This will include:
          <ul>
            <li>Update personal information</li>
            <li>Change password</li>
            <li>Notification preferences</li>
            <li>Company information management</li>
          </ul>
        </Alert>
      </Paper>
    </Box>
  );
};

export default ProfilePage;
